import React from 'react';
import { InfoCircleOutlined } from '@ant-design/icons';
import SummaryCards from './SummaryCards';
import IndexAnalysisSection from './IndexAnalysisSection';
import KeywordPrecisionSection from './KeywordPrecisionSection';
import DiagnosticSection from './DiagnosticSection';
import RankTrendChart from './RankTrendChart';
import MarketTrendSection from './MarketTrendSection';
import KeywordAnalysisCard from './KeywordAnalysisCard';
import KeywordTablesSection from './KeywordTablesSection';
import CompetitorTagsCard from './CompetitorTagsCard';
import CompetitorRankingCard from './CompetitorRankingCard';
import PricePositioningSection from './PricePositioningSection';
import ReviewAnalysisSection from './ReviewAnalysisSection';

import { MOCK_REPORT } from '../mockData';

const MOCK_TAGS_STATE = {
    loading: false,
    error: false,
    data: {
        'https://smartstore.naver.com/starbucks': {
            tags: ['텀블러', '스타벅스', '보온'],
            todayVisit: 2310,
            totalVisit: 254100,
        },
        'https://smartstore.naver.com/locknlock': {
            tags: ['텀블러', '보온보냉', '락앤락'],
            todayVisit: 1872,
            totalVisit: 198400,
        },
        'https://smartstore.naver.com/thermos': {
            tags: ['텀블러', '써모스', '진공단열'],
            todayVisit: 1541,
            totalVisit: 142100,
        },
        'https://smartstore.naver.com/komax': {
            tags: ['텀블러', '보온병', '코멕스'],
            todayVisit: 1203,
            totalVisit: 98700,
        },
        'https://smartstore.naver.com/gflex': {
            tags: ['텀블러', '친환경', '아이스'],
            todayVisit: 980,
            totalVisit: 84200,
        },
        'https://smartstore.naver.com/camelbak': {
            tags: ['텀블러', '카멜백', '인슐레이티드'],
            todayVisit: 842,
            totalVisit: 64200,
        },
        'https://smartstore.naver.com/dailyhome': {
            tags: ['텀블러', '보온텀블러', '스탠리텀블러', '이중단열', '500ml'],
            todayVisit: 621,
            totalVisit: 84201,
        },
        'https://smartstore.naver.com/tiger': {
            tags: ['텀블러', '타이거', '마그보틀'],
            todayVisit: 543,
            totalVisit: 45200,
        },
        'https://smartstore.naver.com/blackpink': {
            tags: ['텀블러', '한정판', '콜라보'],
            todayVisit: 712,
            totalVisit: 51200,
        },
        'https://smartstore.naver.com/oxo': {
            tags: ['텀블러', 'OXO', '리유저블'],
            todayVisit: 398,
            totalVisit: 31200,
        },
    },
};

const WatermarkWrapper = ({ children, text = '예시 화면' }) => (
    <div style={{ position: 'relative', width: '100%' }}>
        <div
            style={{
                position: 'absolute',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%) rotate(-6deg)',
                fontSize: '110px',
                fontWeight: 900,
                color: 'rgba(99, 102, 241, 0.09)',
                pointerEvents: 'none',
                zIndex: 2,
                whiteSpace: 'nowrap',
                letterSpacing: '14px',
                userSelect: 'none',
                fontFamily: '"Outfit", "Inter", "Noto Sans KR", sans-serif',
            }}
        >
            {text}
        </div>
        {children}
    </div>
);

const SamplePreview = () => {
    return (
        <div style={{ position: 'relative' }}>
            {/* ── 안내 배너 ── */}
            <div
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: '12px',
                    background: '#eff6ff',
                    border: '1px solid #bfdbfe',
                    padding: '16px 20px',
                    borderRadius: '12px',
                    marginBottom: '28px',
                    color: '#1e40af',
                    fontSize: '13px',
                    fontWeight: 500,
                    boxShadow: '0 2px 8px rgba(37, 99, 235, 0.05)',
                }}
            >
                <InfoCircleOutlined style={{ color: '#2563eb', fontSize: '20px', flexShrink: 0 }} />
                <div style={{ flex: 1, lineHeight: 1.5 }}>
                    현재 조회된 상품 분석 리포트가 없습니다. 아래의{' '}
                    <b>예시 화면 (샘플 데이터: &quot;{MOCK_REPORT.keywordInfo.relKeyword}&quot;)</b>
                    을 통해 N상품종합분석 기능(전체/상위10 지표, 종합진단, 상세 지수 분석, 키워드
                    정밀 분석, 경쟁사 TOP 10, 리뷰 심층 분석, 가격 포지셔닝 등)의 프리미엄 리포트
                    레이아웃을 확인해 보세요!
                </div>
            </div>

            {/* ── 실 상용 컴포넌트를 이용한 100% 일관된 UI ── */}
            <div style={{ display: 'flex', flexDirection: 'column', gap: '32px' }}>
                <WatermarkWrapper text="예시 화면">
                    <SummaryCards report={MOCK_REPORT} />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <IndexAnalysisSection
                        report={MOCK_REPORT}
                        keyword={MOCK_REPORT.keywordInfo.relKeyword}
                    />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <KeywordPrecisionSection
                        report={MOCK_REPORT}
                        keyword={MOCK_REPORT.keywordInfo.relKeyword}
                    />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <DiagnosticSection report={MOCK_REPORT} />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <RankTrendChart report={MOCK_REPORT} />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <MarketTrendSection report={MOCK_REPORT} />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <KeywordAnalysisCard
                        report={MOCK_REPORT}
                        keyword={MOCK_REPORT.keywordInfo.relKeyword}
                    />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <KeywordTablesSection report={MOCK_REPORT} />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <CompetitorTagsCard
                        report={MOCK_REPORT}
                        tagsState={MOCK_TAGS_STATE}
                        onRetryTags={() => {}}
                    />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <CompetitorRankingCard
                        report={MOCK_REPORT}
                        tagsState={MOCK_TAGS_STATE}
                        onRetryTags={() => {}}
                        isSample={true}
                    />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <PricePositioningSection report={MOCK_REPORT} />
                </WatermarkWrapper>

                <WatermarkWrapper text="예시 화면">
                    <ReviewAnalysisSection report={MOCK_REPORT} />
                </WatermarkWrapper>

                <div style={{ height: 40 }} />
            </div>
        </div>
    );
};

export default SamplePreview;
